import CallIcon from 'components/atoms/icons/callIcon';
import phoneNumbers from 'constants/phoneNumbers';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { addDragListener } from 'utils/dragListener';
import { isPractice } from 'utils/userTypeHelper';

const useCallButtons = ({
  patientGuid,
  profile,
  doctor,
  patient,
  patientDetailsLoading,
  isCcmPanel,
  isRpmPanel,
  userType,
  setManualEnteredCallPopupOpen,
}) => {
  const {
    connect: { handleConnectPopoutOpen, connectDetails },
  } = useDispatch();

  const onClickConnect = (phoneNumber, isRpmCall) => {
    const details = {
      phone: phoneNumber,
      guid: patientGuid,
      isRpmCall,
    };
    connectDetails(details);
    handleConnectPopoutOpen(true);
    addDragListener('connect-modal', 'connect-modal-header');
  };

  const callButtons = useMemo(
    () => [
      {
        render: true,
        label: 'Call patient primary number',
        icon: CallIcon,
        handleClick: () => onClickConnect(profile.phone, isRpmPanel),
      },
      {
        render: profile.homeNumber,
        label: 'Call patient secondary number',
        icon: CallIcon,
        handleClick: () => onClickConnect(profile.homeNumber, isRpmPanel),
      },
      {
        render: profile.emergencyContactNumber,
        label: 'Call emergency contact',
        icon: CallIcon,
        handleClick: () =>
          onClickConnect(profile.emergencyContactNumber, isRpmPanel),
      },
      {
        render: doctor.phone && !isPractice(userType),
        label: 'Call primary doctor',
        icon: CallIcon,
        handleClick: () => onClickConnect(doctor.phone, isRpmPanel),
      },
      {
        render: true,
        label: 'Call translation service',
        icon: CallIcon,
        handleClick: () =>
          onClickConnect(phoneNumbers.TRANSLATION_SERVICE_NUMBER, isRpmPanel),
      },
      {
        render: isCcmPanel,
        label: 'Manual-entered call',
        icon: CallIcon,
        handleClick: () => setManualEnteredCallPopupOpen(true),
      },
    ],
    [patientGuid, profile, doctor, patient, patientDetailsLoading],
  );

  return callButtons;
};

export default useCallButtons;
